import { array } from 'prop-types';

import React from 'react';

import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const AccountNumberWChecksum = ({ account }) => (
  <td className="investment-account-number">
    {`${account.accountNumber}-${account.accountChecksum}`}
  </td>
);

const AccountNumberWithPermissions = WithUserPermissions(
  AccountNumberWChecksum
);

const InvestmentsTable = ({ accountsWithBeneficiaries }) => {
  return accountsWithBeneficiaries ? (
    <table>
      <thead>
        <tr>
          <th>Investment Name</th>
          <th>Account Number</th>
        </tr>
      </thead>
      <tbody>
        {accountsWithBeneficiaries.map((account, i) => {
          return (
            <tr key={i} className="investment-row">
              <td>
                {account.accountName}
                <span className="investment-ticker">{account.ticker}</span>
              </td>
              <AccountNumberWithPermissions account={account} shouldMask />
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : null;
};

InvestmentsTable.propTypes = {
  accountsWithBeneficiaries: array.isRequired
};

InvestmentsTable.defaultProps = {
  accountsWithBeneficiaries: []
};

export default InvestmentsTable;
